import AxiosInterceptor from "../../AxiosInterceptorHearro";

// push 캠페인 등록
export function postPushMessageToHearro(request) {
    return AxiosInterceptor({
        url: '/push/camp',
        method: 'post',
        data: request
    })
}

// push 캠페인 조회
export function getPushMessageFromHearro(request) {
    return AxiosInterceptor({
        url: '/push/camp',
        method: 'get',
        params: request
    })
}